input-select-option = Option auswählen

input-filled-automatically = automatisch gefüllt
input-filled-manually = bitte eintragen

input-combobox-label-selected = { $label }, gewählt: { $selected }
input-combobox-label-search = { $label } suchen
input-combobox-placeholder-search = Suche
input-combobox-show-all-selected = Alle gewählten

input-rich-text-label = Editor: {$label}
input-rich-text-toolbar-label = Werkzeugleiste
input-rich-text-undo = Rückgängig
input-rich-text-redo = Wiederherstellen
input-rich-text-style-normal = Normal
input-rich-text-paragraph-indent = Erstzeileneinzug
input-rich-text-style-h2 = Überschrift 1
input-rich-text-style-h3 = Überschrift 2
input-rich-text-style-h4 = Überschrift 3
input-rich-text-style-blockquote = Zitat
input-rich-text-list-bullets = Aufzählungszeichen
input-rich-text-list-numbers = Nummerierung
input-rich-text-list-sink-list-item = Einzug vergrößern
input-rich-text-list-lift-list-item = Einzug verkleinern
input-rich-text-format-bold = Fett
input-rich-text-format-italics = Kursiv
input-rich-text-format-underline = Unterstrichen
input-rich-text-link = Link
input-rich-text-link-url = Link einfügen
input-rich-text-link-remove = Link entfernen
input-rich-text-emoji = Emoji
input-rich-text-open-single-quote = ‚
input-rich-text-close-single-quote = ‘
input-rich-text-open-double-quote = „
input-rich-text-close-double-quote = “
